import Attribute from "./Attribute";

class EnumAttribute extends Attribute {
    constructor(name, def) {
        super(name, def);
        this.type = 'enum';
        this.subtype = def.type.enumtype;
        this.values = def.type.values;
    }
    getValues(){
        switch (this.subtype) {
            case 'PaymentType':
                return {'swish': 'Swish', 'bg': 'Bankgiro', 'cache': 'Kontant', 'invoice': 'Faktura', 'classchange': 'Klassbyte', 'free': 'Fri start', 'return': 'Återbetalning'};
            case 'ReadingType':
                return {'bib': 'Nummerlapp', 'time': 'Tid'};
            default:
                return {};
        }
    }
}



export default EnumAttribute;